// Поле ввода пульта: shadcn 4.21.1 (base-mira, Base UI), подогнано под ui-spec §4 (задача D4):
// `h-8` и текст 13 px (на телефоне — `h-10` и 16 px из index.css: меньше — и iOS приближает страницу), фон панели
// `--card`, рамка `--input` (≥ 3:1), ошибка — рамка `--destructive`. Фокус — общее кольцо `:focus-visible`
// из index.css; отключённая обводка, бледное кольцо и переход цвета убраны (анимируем только transform и opacity).
import { Input as InputPrimitive } from '@base-ui/react/input';
import { cn } from 'cn';
import type * as React from 'react';

function Input({ className, type, ...props }: React.ComponentProps<'input'>) {
  return (
    <InputPrimitive
      type={type}
      data-slot="input"
      className={cn(
        'h-8 w-full min-w-0 rounded-md border border-input bg-card px-2.5 text-base text-foreground placeholder:text-muted-foreground file:inline-flex file:h-6 file:border-0 file:bg-transparent file:text-sm file:font-medium file:text-foreground disabled:pointer-events-none disabled:cursor-not-allowed disabled:opacity-50 aria-invalid:border-destructive max-sm:h-10',
        className,
      )}
      {...props}
    />
  );
}

export { Input };
